
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FirmwareUpdates extends Vue {
  public created() {
    window.location.replace("https://sensefly.zendesk.com/hc/en-us/sections/115001145107");
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/FirmwareUpdates/FirmwareUpdates.vue